//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'navigation',
    props: ['page'],
    methods: {
        is: function is(url) {
            return this.page.startsWith(url);
        }
    },
    computed: {
        canAccessUsers: function canAccessUsers() {

            var u = window.user.can,
                roles = ['create-all', 'read-all', 'update-all', 'delete-all', 'edit-settings-all', 'create-user', 'read-user', 'update-user', 'delete-user', 'edit-settings-user'];

            roles.forEach(function (r) {
                if (u[r]) {
                    return true;
                }
            });

            return false;
        },
        isUserSuperAdmin: function isUserSuperAdmin() {
            return window.user.role === 'super-admin';
        },
        isUserAbleToNotify: function isUserAbleToNotify() {
            return this.allowedRolesToNotify.contains(window.user.role);
        }
    },
    data: function data() {
        return {
            loading: true,
            collapsed: false,
            currentHovered: '',
            allowedAdminUserRoles: ['super-admin', 'corporate-admin', 'accounting-admin'],
            allowedRolesToNotify: ['super-admin', 'regional-manager', 'property-manager'],
            role: window.user.role
        };
    },
    mounted: function mounted() {
        var $el = this;
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/layout/LeftNavigation.vue
// module id = vHqK
// module chunks = 0 1